'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var moleculeClass = 'fees-contact';

var renderFees = function renderFees(fees) {
  if (fees) {
    return _react2.default.createElement(
      'span',
      { className: moleculeClass + '__fees' },
      fees.text
    );
  }
  return null;
};

var renderLegalText = function renderLegalText(legalText) {
  if (legalText && legalText.text) {
    return _react2.default.createElement(
      'span',
      { className: moleculeClass + '__legal legal-notes' },
      legalText.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: moleculeClass + '__hatch-text hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var FeesContact = function FeesContact(props) {
  var _props$content = props.content,
      fees = _props$content.fees,
      hatchText = _props$content.hatchText,
      legalText = _props$content.legalText;


  return _react2.default.createElement(
    'div',
    { className: moleculeClass + ' col-md-10 col-xs-12 col-sm-9' },
    renderFees(fees),
    renderHatchText(hatchText),
    renderLegalText(legalText)
  );
};

exports.default = FeesContact;


FeesContact.propTypes = {
  content: _propTypes2.default.shape({
    fees: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    legalText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  })
};

FeesContact.defaultProps = {
  content: {
    fees: {
      text: '40 characters maximum per line'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    legalText: {
      text: '* 266 characters is recommended for viewing on a mobile device.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/fees-calculator-contact/jsx/FeesContact.js
// module id = 664
// module chunks = 4